export var defaultPopupBaseProps = {
  closeOnMaskClick: false,
  destroyOnClose: false,
  disableBodyScroll: true,
  forceRender: false,
  getContainer: function getContainer() {
    return document.body;
  },
  mask: true,
  showCloseButton: false,
  stopPropagation: ['click'],
  visible: false
};